import AxiosClient from "../../../services/axios.services";

class UnlinkCategoriesServices {
  getUnlinkCategories = (params) =>
    AxiosClient.get("/api/app/sanciones_categoria_desvinculacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveUnlinkCategories = (data) =>
    AxiosClient.post("/api/app/sanciones_categoria_desvinculacion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editUnlinkCategories = (id, data) =>
    AxiosClient.put(`/api/app/sanciones_categoria_desvinculacion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteUnlinkCategories = (id) =>
    AxiosClient.delete(`/api/app/sanciones_categoria_desvinculacion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new UnlinkCategoriesServices();
